import React from 'react'
import { Link } from 'react-router-dom';
import Presentation from '../components/Presentation'
import History from '../components/History'
import AboutPartners from '../components/AboutPartners';

const About = () => {
  return (
    <main>
      <section className="presentation-section">
        <Presentation />
        <div className='catch-phrase'>
          <p>
            BMS influence l'esport, l'esport influence le monde
          </p>
          <div className='invisible'>
            <Link to="/about" className='about-btn'>En savoir plus</Link>
          </div>
        </div>
      </section>
      <div className="separator w-full max-w-6xl mx-auto mb-[100px] px-4">
        <hr className="border-t-2 border-[#e0e0e0] opacity-75" />
      </div>
      <section className='history-section'>
        <History />
      </section>
      <section className='about-partners-section'>
          <AboutPartners />
        </section>
  </main>
  )
}

export default About